import React from 'react'
import { createUseClasses, MEDIA } from '../common'

//  hooks

const useClasses = createUseClasses({
  button: { '-webkit-appearance': 'none', background: 'transparent', border: '1px solid #dfdfdf', cursor: 'pointer', padding: [8, 8, 6] },
  by: { display: 'block' },
  caret: { color: '#aaa', paddingLeft: 6, paddingRight: 2 },
  div: { marginBottom: 16, position: 'relative' },
  email: { marginLeft: 10 },
  form: { margin: [44, 0, 48] },
  input: { '-webkit-appearance': 'none', border: '1px solid #dfdfdf', padding: [8, 8, 6], width: 293 },
  [MEDIA.mobile]: {
    email: { display: 'block', marginLeft: 0 },
    textarea: { width: 293 }
  },
  [MEDIA.mobileTablet]: {
    span: { display: 'block', left: 'auto', marginBottom: 10, position: 'static', textAlign: 'left', top: 'auto', width: 'auto' }
  },
  span: { display: 'inline-block', left: -260, paddingRight: 10, position: 'absolute', textAlign: 'right', top: 12, width: 250 },
  textarea: { '-webkit-appearance': 'none', border: '1px solid #dfdfdf', height: 150, padding: [5, 8], resize: 'none', width: 460 }
})

// components

export const Contact = () => {
  const classes = useClasses()

  return (
    <form action="/api/contact" className={classes.form} method="post" name="contact">
      <div className={classes.div}>
        <label>
          <span className={classes.span}>貴社名 / Company Name:</span>

          <input className={classes.input} name="company" type="text" />
        </label>
      </div>

      <div className={classes.div}>
        <label>
          <span className={classes.span}>お名前 / Name:</span>

          <input className={classes.input} name="name" type="text" />
        </label>
      </div>

      <div className={classes.div}>
        <label>
          <span className={classes.span}>お電話番号 / Phone Number:</span>

          <input className={classes.input} name="phone" type="text" />
        </label>
      </div>

      <div className={classes.div}>
        <label>
          <span className={classes.span}>ご住所 / Address:</span>

          <input className={classes.input} name="address" type="text" />
        </label>
      </div>

      <div className={classes.div}>
        <label>
          <span className={classes.span}>メールアドレス / Email:</span>

          <input className={classes.input} name="email" type="text" />
        </label>
      </div>

      <div className={classes.div}>
        <label>
          <span className={classes.span}>WEBサイト / Website URL:</span>

          <input className={classes.input} name="url" type="text" />
        </label>
      </div>

      <div className={classes.div}>
        <label>
          <span className={classes.span}>お問い合わせ内容 / Message:</span>

          <textarea className={classes.textarea} name="message" />
        </label>
      </div>

      <div>
        <button className={classes.button} type="submit">
          送信 / Send<span className={classes.caret}>&gt;</span>
        </button>
      </div>
    </form>
  )
}
